import React from 'react'
import {connect} from 'react-redux'
import { Container, Row, Col} from 'reactstrap';
import ReportResRow from '../components/ReportResRow'
import {formatCurrency} from '../utils/Strings'

const mapStateToProps = state => {  
  return {    
    reservations: state.report.reservations,
    ticketUrlPath: state.report.ticketUrlPath,
    filter: state.report.resFilter,
    infoText: state.report.resInfo
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return { 
//      onCourseChoose: (ownProps, courseIdx) => {        
//        dispatch(setCourse(courseIdx))
//      },
//    onGetCourses: (ownProps) => {          
//      dispatch(fetchCourses(ownProps.agentLogin))
//    },    
  }
}

class ReportList extends React.Component{
  constructor (props) {
    super(props)
    this.state = {      
//      onCourseChoose: props.onCourseChoose,     
    };
//    this.handleCourseChoose = this.handleCourseChoose.bind(this);
  }
//  handleCourseChoose(idx){
//    //alert('Wybrano ' + idx)
//    this.state.onCourseChoose(this.state, idx)
//  }
  renderInfoText() {
    return (
      <p className="center"><br/>{this.props.infoText}</p>
    )
  }
  render() {
    if (this.props.infoText.length>0)
      return this.renderInfoText()

    if (this.props.reservations.length>0){
      var qtyNormalSum=0
      var qtyReducedSum=0
      var totalPriceSum=0.00
      for(var i=0; i<this.props.reservations.length; i++){
        var r=this.props.reservations[i]
        if (r.isPaid || (parseInt(r.statusTrans, 10) === 10)){
          qtyNormalSum += parseInt(r.qtyNormal, 10)
          qtyReducedSum += parseInt(r.qtyReduced, 10)
          totalPriceSum += parseFloat(r.totalPrice)
        }
      }
      var strQty=''
      if (qtyNormalSum>0)
        strQty += qtyNormalSum + "N "
      if (qtyReducedSum>0)
        strQty += qtyReducedSum + "U"
      
      return (      
        <Container fluid={true} className="defList">
          <h3>Lista rezerwacji</h3>
          {this.props.reservations.map((reservation, index) => (            
            <ReportResRow 
              key={index} 
              index={index}
              reservation={reservation}  
              ticketUrlPath={this.props.ticketUrlPath}              
            />
          ))}
          <Row className="align-items-center sumRow">
            <Col md="10" xs="3">
            RAZEM:
            </Col>
            <Col md="1" xs="1">
            {strQty}
            </Col>
            <Col md="1" xs="2">
            {formatCurrency(totalPriceSum)}
            </Col>
          </Row>
        </Container>
      )
    }
    else
      return this.renderInfoText()
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportList)    


// WEBPACK FOOTER //
// ./src/containers/ReportResList.js